import * as React from 'react';

import { useAtomValue } from 'jotai';

import { $remoteSalesOrderActiveLoads } from '../../../_state/salesOrderDetail.state';

export const useCanFinishSalesOrder = ({
  salesOrderId,
  enabled = true,
}: {
  salesOrderId?: string | null;
  enabled?: boolean;
}) => {
  const { data: salesOrderActiveLoad, isLoading } = useAtomValue(
    $remoteSalesOrderActiveLoads(enabled ? salesOrderId : null),
  );

  const canFinish = React.useMemo(
    () => !salesOrderActiveLoad?.loads?.length,
    [salesOrderActiveLoad?.loads],
  );

  const blockers = React.useMemo(
    () =>
      salesOrderActiveLoad?.loads
        ?.map((load) => `# ${load.documentNumber}`)
        ?.join(', '),
    [salesOrderActiveLoad?.loads],
  );

  return {
    canFinish,
    blockers,
    isLoading,
  };
};
